var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnInfoBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 0C10.866 0 14 3.13401 14 7C14 10.866 10.866 14 7 14C3.13401 14 0 10.866 0 7C0 3.13401 3.13401 0 7 0ZM7.79064 6H5.5V7.32239H6.26847V9.67761H5.5V11H8.5V9.67761H7.79064V6ZM7.00565 3C6.86252 3 6.72976 3.02622 6.60734 3.07865C6.48493 3.13109 6.37853 3.20225 6.28814 3.29213C6.19774 3.38202 6.12712 3.48783 6.07627 3.60955C6.02542 3.73127 6 3.86142 6 4C6 4.13858 6.02542 4.26873 6.07627 4.39045C6.12712 4.51217 6.19774 4.61798 6.28814 4.70787C6.37853 4.79775 6.48493 4.86891 6.60734 4.92135C6.72976 4.97378 6.86252 5 7.00565 5C7.14124 5 7.2693 4.97378 7.38983 4.92135C7.51036 4.86891 7.61582 4.79775 7.70621 4.70787C7.79661 4.61798 7.86817 4.51217 7.9209 4.39045C7.97363 4.26873 8 4.13858 8 4C8 3.86142 7.97363 3.73127 7.9209 3.60955C7.86817 3.48783 7.79661 3.38202 7.70621 3.29213C7.61582 3.20225 7.51036 3.13109 7.38983 3.07865C7.2693 3.02622 7.14124 3 7.00565 3Z",
    fill: "#2D72FE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnInfoBlue);
export default __webpack_public_path__ + "static/media/icn_info_blue.85854052f3990e419277d7627d4c42d8.svg";
export { ForwardRef as ReactComponent };